import { once } from "lodash";
import React, { createContext, useContext } from "react";
import { getGridRowClasses, getGridRowStyles } from "../../GridStyles";
import { getRowMetadata } from "../../functions/getRowMetadata";
import { EditableGridRow } from "./EditableGridRow";
export function EditableRowRenderer({ index: rowIndex, style: styles, data }) {
    const { page, rows, allowPagination, rowIndexOnEdit } = data;
    const rowContext = useContext(createEditableGridRowContext());
    if (!rowContext) {
        throw new Error("Row context is missing.");
    }
    const { allowSelection, columns, displayRowStyle, editableRowStyle, getColumnWidth, getRowProps, getIsRowLoading, getIsRowReadOnly, prepareRow } = rowContext;
    const row = allowPagination ? page[rowIndex] : rows[rowIndex];
    if (!row) {
        return null;
    }
    const isEditing = rowIndexOnEdit == row.index;
    const { isRowLoading, isRowReadOnly } = getRowMetadata({ row, getIsRowLoading, getIsRowReadOnly });
    const rowStyles = getGridRowStyles({
        isRowReadOnly,
        row,
        rowPropsClassName: getRowProps ? getRowProps(row).className : undefined
    });
    const rowClasses = getGridRowClasses({
        isRowReadOnly,
        defaultRowClasses: ["editable-grid-row"],
        row,
        rowPropsClassName: getRowProps ? getRowProps(row).className : undefined
    });
    const customGetRowProps = (row) => {
        const style = {
            ...styles,
            ...(isEditing ? editableRowStyle : displayRowStyle),
            ...(getRowProps && getRowProps(row).style),
            width: "inherit"
        };
        return {
            onKeyDown: (e) => {
                if (getRowProps && getRowProps(row).onClick) {
                    if (!isRowReadOnly && (e.key === "Enter" || e.key === " ")) {
                        e.currentTarget.click();
                    }
                }
            },
            ...(getRowProps && getRowProps(row)),
            className: rowClasses.join(" "),
            style: style
        };
    };
    prepareRow(row);
    return (React.createElement(EditableGridRow, { allowSelection: allowSelection, columns: columns, getColumnWidth: getColumnWidth, getRowProps: customGetRowProps, isEditing: isEditing, isRowLoading: isRowLoading, isRowReadOnly: isRowReadOnly, row: row, rowIndex: rowIndex, sx: rowStyles }));
}
export const createEditableGridRowContext = once(() => {
    return createContext(null);
});
